import React, { Fragment, useState, useEffect } from 'react';
import "moment/locale/es";
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';

const AdmissionFormat = ({ data, openFormat, setOpenformat }) => {

    const urlLogo =  'https://i.postimg.cc/WpG6Rg5q/logo-SAC-App-New.png';
    const [loading, setLoading] = useState(true);
    const [age,setAge] = useState('');
    const [today, setToday] = useState('');

    useEffect(() => {
        console.log(data);     
        calculateAge(data.original.birthday);       
    
      }, []);


    const calculateAge = (birthday) => {

        let hoy = new Date();
        let cumpleanos = new Date(birthday);

        let edad = hoy.getFullYear() - cumpleanos.getFullYear();

        let meses = hoy.getMonth() - cumpleanos.getMonth();
        

        if (meses < 0 || (meses === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }        

        let cantMeses = meses;

        if(meses <= 0){
            cantMeses = 12 + meses;
        }

        let edadTotal = edad + ' años ' ;
        //let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
        //let hoy = new Date();
        //let fecTemp = fecha;

        setAge(edadTotal);
        setToday(hoy);
        //console.log(age);
        createFormat();
    }

    const getBase64ImageFromURL = (url)  => {

        return new Promise((resolve, reject) => {
            let img = new Image();
            img.setAttribute("crossOrigin", "anonymous");

            img.onload = () => {
                let canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                let dataURL = canvas.toDataURL("image/png");

                resolve(dataURL);
            };

            img.onerror = error => {
                reject(error);
            };

            img.src = url;
        });
    }

    const createFormat = async() =>{

        const header = {
            margin: [10, 10, 0, 0],
            layout: 'noBorders',
            table: {
                widths: ['*', '*'],
                body: [
                    [{
                        image: await getBase64ImageFromURL(urlLogo),
                        width: 80,
                        height: 30,
                        alignment: 'center'
                    },
                    { text: 'UNIDAD DE ESPECIALIDADES MEDICAS S.A.S.', style: 'head' }],

                ]
            },
        };

        const foter = {
           text: 'Usuario y Fecha de Impresión ' + today, style: 'head',
        };

        const documentDefinition = {
            pageSize: 'LETTER',
            pageOrientation: 'portrait',
            header: header,
            footer: foter,
            content:[
                {
                    text: 'Ingreso No. ' + data.original.id_admision, style: 'medicStyle'
                },
                {
                    // auto-sized columns have their widths based on their content                                       
                    margin: [0, 5, 0, 0],                    
                    table: {                        
                        widths: ['*', '*', '*'],
                        body: [
                            [{ text: 'Fecha de Ingreso: ' + data.original.fecha, style: 'textStyle' }, { text: 'Hora: ' + data.original.hora, style: 'textStyle' },''],
                            [{ text: 'Cliente ' , style: 'textStyle' }, '',''],                           
                            [{ text: 'Paciente ',  style: 'textStyle' }, { text: data.original.fullname, style: 'textStyle' }, ''],
                            [{ text: 'Fecha de Nacimiento/Edad ',  style: 'textStyle' }, { text: age, style: 'textStyle' }, { text: 'Telefono: ' + data.original.celular + '-' + data.original.telefono,  style: 'textStyle' }],
                            [{ text: 'Dirección ',  style: 'textStyle' }, { text: data.original.direccion, style: 'textStyle' }, ''],
                            [{ text: 'Autorizacion No. 0', style: 'textStyle' }, { text: 'Validacion No. 0', style: 'textStyle' }, ''],
                            [{ text: 'Medico ', bold: true, style: 'textStyle' }, '',''],
                        ]
                    },
                },
                {
                    // auto-sized columns have their widths based on their content                                       
                    margin: [0, 0, 0, 10],                    
                    table: {                        
                        widths: ['*', ],
                        headerRows: 1,
                        body: [
                            [{ text: 'Actividades' , style: 'tableheader' } ],
                            [{ text: data.original.servicios.id_servicio + ' - ' + data.original.servicios.nombre , style: 'textStyle' }],                           
                            
                        ]
                    },
                }
            ],
            styles: {
                head: {
                    fontSize: 7,
                    bold: true,
                    alignment: 'left'
                },
                tableheader: {
                    fontSize: 11,
                    bold: true,

                },
                textStyle: {
                    fontSize: 9,
                },
                tableTexStyle: {
                    fontSize: 8,
                    alignment: 'left'
                },
                foter: {
                    margin: 10,
                    fontSize: 6,
                },
                medicStyle: {
                    margin: [0, 80, 0, 0],
                    fontSize: 10,
                    alignment: 'left',
                }
            }
        };

        pdfMake.createPdf(documentDefinition).open();
        setLoading(false);       
    }

    return (<Fragment>
        {loading ? <Modal
            open={openFormat}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
        >
            <div style={{
                position: 'absolute',
                backgroundColor: '#ffffff',
                width: 200,
                height: 200,
                backgroundColor: 'white',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                display: 'flex'
            }}
            >
                <div className="load__icon-wrap">
                    <svg className="load__icon">
                        <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                    </svg>
                </div>
            </div>

        </Modal> : null} 
        </Fragment>
    );
}

export default AdmissionFormat;